<template>
  <div class="store__home__page">
    <div class="content">
      <div class="store__home__page__tips" v-if="store.notice">
        <div class="store__home__page__tips__title">
          <div class="store__home__page__tips__title__left">
            <img :src="require('@/assets/img/gonggao.png')" alt="" />
            公告
          </div>
          <div v-if="showButton" @click="toogle" class="store__home__page__tips__title__right vertical-align pointer">
            <span class="middle">{{ showText }}</span>
            <img class="middle single" :style="singleStyle" src="@/assets/store/single.png" />
          </div>
        </div>
        <div
          ref="notice"
          :style="lineStyle"
          :class="{ store__home__page__tips__content: true, overflow: this.showMore }"
        >
          {{ store.notice }}
        </div>
      </div>
      <div class="store__home__page__tips">
        <div class="store__home__page__tips__title">
          <div class="store__home__page__tips__title__left">
            <img :src="require('@/assets/store/peisong.png')" alt="" />
            <span style="color: #000">配送方式</span>
          </div>
        </div>
        <div v-if="qualifications.delivery" :style="lineStyle" :class="{ store__home__page__tips__content: true }">
          {{ price(qualifications.delivery.minDeliveryAmount) }}元起送，{{
            price(qualifications.delivery.parcelAmount)
          }}元包邮，不足包邮金额需支付{{ price(qualifications.delivery.freight) }}元运费，{{ qualifications.delivery.remark }}
        </div>
      </div>
      <div v-if="qualifications.invoice" class="store__home__page__tips">
        <div class="store__home__page__tips__title">
          <div class="store__home__page__tips__title__left">
            <img :src="require('@/assets/store/fapiao.png')" alt="" />
            <span style="color: #000">发票说明</span>
          </div>
        </div>
        <div :style="lineStyle" :class="{ store__home__page__tips__content: true }">
          支持开具{{ invoiceDesc }}，支持{{ qualifications.invoice.sendTime }}，如有遗漏，请联系客服。
        </div>
      </div>
      <div v-if="qualifications.refundNotice" class="store__home__page__tips">
        <div class="store__home__page__tips__title">
          <div class="store__home__page__tips__title__left">
            <img :src="require('@/assets/store/shouhou.png')" alt="" />
            <span style="color: #000">售后说明</span>
          </div>
        </div>
        <div :style="lineStyle" :class="{ store__home__page__tips__content: true }">
          {{ qualifications.refundNotice }}
        </div>
      </div>
      <template v-if="hotSaleGoodsList.length">
        <CouponBanner v-if="couponList.length" :list="couponList" />
        <SpecialGoods
          @update-cart="$emit('update-cart')"
          v-if="specialGoodsList.length"
          :goodsList="specialGoodsList"
          @click-more="linkToGoods('特价')"
        />
        <HotSale @update-cart="$emit('update-cart')" :goodsList="hotSaleGoodsList" @click-more="linkToGoods" />
      </template>
      <div class="empty" v-else>
        <img class="empty__logo" src="@/assets/img/shop-empty.png" />
        <div class="empty__text">店铺努力上架中，敬请期待</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import CouponBanner from './components/CouponBanner';
import HotSale from './components/HotSale';
import SpecialGoods from './components/SpecialGoods';
import { priceFenToYuan } from '@/helpers/utils'

export default {
  props: {
    row: {
      type: Number,
      default: 2
    },
    lineHeight: {
      type: Number,
      default: 18
    }
  },
  components: { CouponBanner, HotSale, SpecialGoods },
  inject: ['storeRef', 'shopId'],
  computed: {
    store() {
      return this.storeRef.$data.store || {};
    },
    showText() {
      return this.showMore ? '展开' : '收起';
    },
    singleStyle() {
      const transformType = 'rotate';
      const value = `${transformType}(${!this.showMore ? '-180deg' : '0'})`;
      const style = {
        transform: value
      };
      return style;
    },
    lineStyle() {
      return {
        '-webkit-line-clamp': this.row
      };
    }
  },
  data() {
    return {
      showMore: false,
      showButton: false,
      hotSaleGoodsList: [],
      specialGoodsList: [],
      couponList: [],
      searchRecommendGoodsParams: {
        pageNo: 1,
        pageSize: 30,
        // 排序类型：1-综合排序，2-销量排序，3-月销店数降序
        orderType: 2,
        aggregateFlag: false
      },
      searchSpecialGoodsParams: {
        pageNo: 1,
        pageSize: 30,
        itemActivityLabel: '特价',
        // 排序类型：1-综合排序，2-销量排序，3-月销店数降序
        orderType: 2,
        aggregateFlag: false
      },
      qualifications: {}
    };
  },
  methods: {
    price(val) {
      return priceFenToYuan(val);
    },
    toogle() {
      this.showMore = !this.showMore;
    },
    initHeight() {
      if (this.$refs.notice) {
        const notice = this.$refs.notice;
        let { offsetHeight } = notice;
        if (offsetHeight > this.row * this.lineHeight) {
          this.showMore = true;
          this.showButton = true;
        }
      }
    },
    // 获取优惠券列表
    // async getCouponList() {
    //   let { shopCouponInfos, platformCouponInfos } = await api.coupon.getCouponList({
    //     shopId: this.shopId,
    //     scene: 4,
    //     couponScope: 1
    //   });
    //   shopCouponInfos = shopCouponInfos || [];
    //   platformCouponInfos = platformCouponInfos || [];
    //   this.couponList = [...shopCouponInfos, ...platformCouponInfos];
    // },
    // 获取热销商品列表
    async getHotSaleGoods() {
      const {
        data: { itemBasicInfos }
      } = await api.goods.getGoodsList({
        ...this.searchRecommendGoodsParams,
        shopId: this.shopId,
        saleOutStatus: 2 // 查询售罄状态： 0 未售罄 1售罄 2全部(未售罄+售罄) 默认 0 未售罄
      });
      this.hotSaleGoodsList = itemBasicInfos || [];
    },
    // 获取特价商品列表
    async getSpecialGoods() {
      const {
        data: { itemBasicInfos }
      } = await api.goods.getGoodsList({
        ...this.searchSpecialGoodsParams,
        shopId: this.shopId,
        saleOutStatus: 2 // 查询售罄状态： 0 未售罄 1售罄 2全部(未售罄+售罄) 默认 0 未售罄
      });
      this.specialGoodsList = itemBasicInfos || [];
    },
    linkToGoods(label) {
      this.$router.push({ path: `/store/${this.shopId}/goods`, query: { label } });
    },
    async getExtension() {
      this.qualifications = await api.shop.getExtension({ shopId: this.shopId });
    }
  },
  mounted() {
    this.initHeight();
  },
  created() {
    // this.getCouponList();
    this.getHotSaleGoods();
    this.getSpecialGoods();
    this.getExtension();
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
.store__home__page {
  padding-top: 16px;
  background: #f5f5f5;

  padding-bottom: 56px;
  &__tips {
    padding: 16px;
    background: #ffffff;
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      &__left {
        font-size: 16px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
        display: flex;
        align-items: center;
        img {
          height: 16px;
          margin-right: 4px;
        }
      }
      &__right {
        font-size: 12px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
        .single {
          width: 5px;
          height: 3px;
          margin-left: 4px;
          transition: transform 0.5s ease;
        }
      }
    }
    &__content {
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1.5;
    }
    .overflow {
      @include multiEllipsis;
    }
  }

  &__tips + &__tips {
    margin-top: 16px;
  }

  & > div + div {
    margin-top: 16px;
  }
  .empty {
    padding-bottom: 238px;
    text-align: center;
    background: #f5f5f5;
    &__logo {
      width: 220px;
      height: 220px;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
}
</style>
